import React from "react";

const eur = (v) => `€${Number(v || 0).toFixed(2)}`;

export const itemsSubtotal = (order) =>
  (order.items || []).reduce((s, it) => s + Number(it.price ?? it.article?.price ?? 0) * Number(it.quantity || 0), 0);

/** Subtotale articoli → Spedizione → Sconto → Totale pagato / da pagare. */
export const OrderPaymentSummary = ({ order }) => {
  const subtotal = itemsSubtotal(order);
  const shipping = Number(order.shipping_cost || 0);
  const discount = Number(order.discount_amount ?? order.coupon?.discount_amount ?? 0);
  const total = Number(order.total_amount || 0);
  const method = (order.payment_method || "").toLowerCase();
  const isTransfer = ["transfer", "bank_transfer", "bonifico"].includes(method);
  const paidFlag = (order.payment_status || "").toLowerCase() === "paid";
  const awaitingTransfer = isTransfer && !paidFlag && order.status === "pending";
  const awaitingOnline = !isTransfer && (order.payment_status || "").toLowerCase() === "awaiting_payment" && order.status === "pending";
  const cancelled = order.status === "cancelled";

  const totalLabel = cancelled
    ? "Totale ordine (annullato)"
    : awaitingTransfer
      ? "Totale da pagare con bonifico"
      : awaitingOnline
        ? "Totale in attesa di pagamento"
        : "Totale pagato";
  const totalColor = cancelled ? "text-gray-500" : awaitingTransfer || awaitingOnline ? "text-orange-600" : "text-green-600";

  const Row = ({ label, value, testid, cls = "text-gray-700" }) => (
    <div className="flex justify-between gap-4" data-testid={testid}>
      <span className="text-gray-600">{label}</span>
      <span className={`font-semibold tabular-nums ${cls}`}>{value}</span>
    </div>
  );

  return (
    <div className="mt-1 mb-2 p-2.5 bg-gray-50 border border-gray-200 rounded-lg text-sm space-y-1" data-testid={`order-payment-summary-${order.id}`}>
      <Row label="Subtotale articoli" value={eur(subtotal)} testid={`order-subtotal-${order.id}`} />
      <Row label="🚚 Spedizione" value={shipping > 0 ? `+ ${eur(shipping)}` : "Gratis"} testid={`order-shipping-${order.id}`} cls="text-orange-600" />
      {discount > 0 && (
        <Row label={`🏷️ Sconto${order.coupon_code || order.coupon?.code ? ` (${order.coupon_code || order.coupon?.code})` : ""}`} value={`− ${eur(discount)}`} testid={`order-discount-${order.id}`} cls="text-pink-700" />
      )}
      <div className={`flex justify-between gap-4 border-t border-gray-300 pt-1.5 mt-1 font-bold ${totalColor}`} data-testid={`order-total-line-${order.id}`}>
        <span>{awaitingTransfer ? "🏦 " : awaitingOnline ? "⏳ " : cancelled ? "" : "✅ "}{totalLabel}</span>
        <span className="tabular-nums text-base">{eur(total)}</span>
      </div>
      {awaitingTransfer && (
        <p className="text-[11px] text-orange-700" data-testid={`order-transfer-hint-${order.id}`}>
          Conferma l'ordine quando il bonifico è accreditato.
        </p>
      )}
    </div>
  );
};
